import Vue from "vue";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import PerfectScrollbarForWindow from "perfect-scrollbar";

// Perfect scrollbar
Vue.use(PerfectScrollbar);
window.PerfectScrollbar = PerfectScrollbarForWindow;
